import React, { useState, useEffect } from 'react';

// Hooks
import { useSelector } from 'react-redux';

// utils
import { MESSAGES } from '~/utils/message.js';
import { balanceFormatter } from '~/utils/helperFunctions.js';
import { dateFormat } from '~/utils/date-format';
import { TRANSACTION_STATUS } from '~/utils/constants';

// Components
import OlcTablePagination from '~/components/General/OlcTablePagination';
import OlcFormModal from '~/components/General/OlcFormModal';

//MUI Component
import Typography from '@mui/material/Typography';
import { Box, Stack, Tooltip } from '@mui/material';
import DataGrid from '~/components/General/OlcDataGrid';

// Icons
import { NoContactCIcon } from '~/assets/images';

// Styles
import './styles.scss';

const TransactionsModal = (props) => {
  const { handleClose, open, updatePagination, transactionsData } = props;
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const loading = useSelector((state) => state.adminUsersReducers.userWalletHistoryLoader) || false;

  const handleChangePage = (event, newPage) => {
    updatePagination({
      page: newPage,
      pageSize: 10,
    });
  };

  const columns = [
    {
      field: 'date',
      headerName: 'Date',
      width: 200,
      sortable: false,
      flex: screenWidth >= 1350 ? 1 : 0,
      renderCell: (params) => <Typography>{dateFormat(params.row.createdAt, true)}</Typography>,
    },
    {
      field: 'transactionId',
      headerName: 'Transaction ID',
      width: 200,
      sortable: false,
      flex: screenWidth >= 1350 ? 1 : 0,
      renderCell: (params) => <Typography>{params.row.id}</Typography>,
    },
    {
      field: 'description',
      headerName: 'Description',
      type: 'number',
      width: 450,
      sortable: false,
      flex: screenWidth >= 1350 ? 1 : 0,
      renderCell: (params) => (
        <Box className="descriptionWrapper">
          <Tooltip title={params.row.remarks}>
            <Typography
              sx={{
                textAlign: 'left !important',
              }}
            >
              {params.row.remarks}
            </Typography>
          </Tooltip>
        </Box>
      ),
    },
    {
      field: 'amount',
      headerName: 'Amount',
      width: 200,
      height: 550,
      sortable: false,
      flex: screenWidth >= 1350 ? 1 : 0,
      renderCell: (params) => {
        const balance = balanceFormatter(params.row.amount);
        return (
          <Typography>
            <span className="icon-color">{TRANSACTION_STATUS[params.row.type]}</span> {balance}
          </Typography>
        );
      },
    },
    {
      field: 'balance',
      headerName: 'Balance',
      width: 200,
      sortable: false,
      flex: screenWidth >= 1350 ? 1 : 0,
      renderCell: (params) => {
        const balance = balanceFormatter(params.row.meta.newBalance);
        return <Typography>{balance}</Typography>;
      },
    },
  ];

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <OlcFormModal
      open={open}
      onClose={handleClose}
      title={MESSAGES.ACCOUNT.WALLET.STRIPE.TRANSACTIONS}
      className="olcAdminFormModal transactionsModalWrapper"
      dialogProps={{ maxWidth: false }}
    >
      <div className="fundsTableWrapperAdmin olcAdminListTable">
        <DataGrid
          rows={transactionsData?.rows || []}
          columns={columns}
          pageSizeOptions={[20, 50, 100]}
          paginationMode="server"
          hideFooterSelectedRowCount
          page={transactionsData?.currentPage || 1}
          loading={loading}
          rowCount={transactionsData?.count}
          hideFooterPagination
          rowSelection={false}
          getRowId={(row) => row?.id}
          disableColumnMenu={true}
          className="fundsTableGrid transactionsTableGrid"
          columnHeaderHeight={47}
          slots={{
            noRowsOverlay: () =>
              transactionsData?.totalRecordsInDB === 0 && (
                <Stack className="noRowsTextContacts">
                  <img src={NoContactCIcon} alt="NoContact" />
                  {MESSAGES.ACCOUNT.WALLET.STRIPE.NO_TRANSACTION}
                </Stack>
              ),
            noResultsOverlay: () => (
              <Stack className="noRowsTextContacts">
                <img src={NoContactCIcon} alt="NoContact" />
                {MESSAGES.NO_ROWS_TEXT}
              </Stack>
            ),
          }}
        />
        {(loading || transactionsData?.total > 0) && (
          <OlcTablePagination
            count={transactionsData?.lastPage || 1}
            page={transactionsData?.currentPage || 1}
            pageSize={10}
            showPageSize={false}
            onPageChange={handleChangePage}
            from={transactionsData?.from || 0}
            to={transactionsData?.to || 0}
            total={transactionsData?.total || 0}
            loading={loading}
          />
        )}
      </div>
    </OlcFormModal>
  );
};

export default TransactionsModal;
